import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallTransferFailed } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  getTransferFailureDescription,
  getTransferTargetName,
} from 'entities/Call/lib/transferTarget'
import { type IEventHandlerOptions } from 'entities/Call/events/types'

export const useEventCallTransferFailed = (options?: IEventHandlerOptions) => {
  const { websocket, inboxesStore, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallTransferFailed) => {
    if (options?.enabled && !options.enabled()) return
    if (!callStore.isOwnTransferLeg(data.agent_call_sid)) return

    callStore.setTransferringCallSid(null)

    const target = getTransferTargetName(data, inboxesStore)

    toastStore.add({
      type: 'error',
      title: `Transfer to ${target} failed`,
      desc: getTransferFailureDescription(data.reason),
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.CallCallTransferFailed, handle), [callStore])
}
